import { useQuery } from "@tanstack/react-query";

export function usePaymentStatus(hash: string, enabled: boolean) {
  const { data } = useQuery({
    queryKey: ["payment-status", hash],
    queryFn: async (): Promise<string | null> => {
      const response = await fetch(
        `/api/session/status?hash=${encodeURIComponent(hash)}`,
      );
      const data = await response.json();

      if (!response.ok || data.error) {
        throw new Error(data.error ?? "Failed to check payment status");
      }

      return data.paidAt ?? null;
    },
    enabled: enabled && !!hash,
    refetchInterval: (query) => (query.state.data ? false : 10000),
    refetchIntervalInBackground: true,
  });

  return data ?? null;
}
